export default "__VITE_ASSET__B$Augu$$__"